export const businessInfo = {
  name: "Drive Inverclyde",
  tagline: "Drive Safe, Drive Smart, Drive Inverclyde",
  phone: "07711 887 858",
  email: "paul@driveinverclyde.co.uk",
  logoUrl: "https://customer-assets.emergentagent.com/job_learn-manual/artifacts/5cs38wa0_DRIVE%20%2812%29.png",
  qualification: "Fully Qualified DVSA Instructor",
  coverageAreas: ["Wemyss Bay", "Inverkip", "Gourock", "Greenock"]
};

export const services = [
  {
    id: 1,
    name: "Automatic Driving Lessons",
    description: "Professional automatic driving lessons with a fully qualified DVSA instructor",
    price: "£40",
    duration: "per hour",
    features: ["Automatic transmission", "Theory test support", "Flexible scheduling", "Patient instructor", "Toyota Yaris (Auto)"]
  },
  {
    id: 2,
    name: "Intensive Courses",
    description: "Fast-track your driving skills with our intensive driving courses",
    price: "",
    duration: "",
    features: ["Accelerated learning", "Block booking discounts", "Test preparation", "Flexible duration"]
  },
  {
    id: 3,
    name: "Pass Plus Training",
    description: "Advanced driving skills to make you a safer, more confident driver",
    price: "",
    duration: "",
    features: ["Motorway driving", "Night driving", "Adverse conditions", "Insurance discounts"]
  },
  {
    id: 4,
    name: "Refresher Lessons",
    description: "Get back behind the wheel with confidence after a break from driving",
    price: "£40",
    duration: "per hour",
    features: ["Confidence building", "Updated road rules", "Parking practice", "Flexible pace"]
  },
  {
    id: 5,
    name: "Mock Tests",
    description: "Practice your driving test with realistic mock examinations",
    price: "£45",
    duration: "per test",
    features: ["Real test conditions", "Detailed feedback", "Route familiarization", "Confidence building"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Amyleigh",
    location: "Greenock",
    text: "I couldn't have asked for a better driving instructor! Paul was incredibly patient, understanding, and supportive throughout every lesson. No matter how many questions I had or mistakes I made, he always stayed calm and encouraging, which made such a huge difference to my confidence. Everything was explained clearly and in a way that was easy to understand. Learning to drive felt stress-free and enjoyable thanks to his positive attitude. I highly recommend Paul to anyone who wants a fantastic learning experience! Thank you so much again, couldn't have done it without you!",
    rating: 5,
    photo: "https://customer-assets.emergentagent.com/job_99a6c986-2fe1-448c-8a49-34deb5cc650b/artifacts/ue92fjla_2026_Amyleigh.jpg",
    result: "2026 Pass"
  },
  {
    id: 2,
    name: "Hollie",
    location: "Greenock",
    text: "Amazing experience with Paul, puts you at ease every single lesson! Wouldn't go anywhere else. Thanks for everything x",
    rating: 5,
    photo: "https://customer-assets.emergentagent.com/job_99a6c986-2fe1-448c-8a49-34deb5cc650b/artifacts/yr6ka0n3_2026_Hollie.jpg",
    result: "2026 Pass"
  },
  {
    id: 3,
    name: "Yanisa",
    location: "Greenock",
    text: "I'm so happy to say I passed my driving test FIRST TIME with only 2 minor faults! 🚗🎉 A huge thank you to Paul for all his help and patience during my lessons. He really helped build my confidence and made learning to drive feel so much easier, especially getting to know the roads around Greenock. I couldn't have done it without his support – highly recommend! 🌟",
    rating: 5,
    photo: "https://customer-assets.emergentagent.com/job_99a6c986-2fe1-448c-8a49-34deb5cc650b/artifacts/0w7b97ma_2026_Yanisa.jpg",
    result: "2026 Pass - First Time, 2 Minors"
  },
  {
    id: 4,
    name: "Michelle",
    location: "Greenock",
    text: "I PASSED on my 1st attempt 🎉🎉🎉 I still can't believe it! Thank you again Paul, you are a fantastic instructor. You really have no idea how much you helped with my nerves and confidence. If it wasn't for your patience (and you needed loads of that 😁) it never would have happened. I really hope you don't miss my chat too much 🤣",
    rating: 5,
    photo: "https://customer-assets.emergentagent.com/job_99a6c986-2fe1-448c-8a49-34deb5cc650b/artifacts/ub8v0o13_2025_Michelle.jpg",
    result: "Passed First Time"
  },
  {
    id: 5,
    name: "Sarah",
    location: "Greenock",
    text: "Paul is a great instructor. I was quite apprehensive about driving after going from test ready to not driving for ten months. Paul really helped rebuild my confidence, listened to the areas I felt less confident on and tried different teaching approaches to help consolidate or revisit different requirements. Flexibility and understanding in lessons made a big difference for me. I felt really safe, and I knew he wouldn't put me forward until I was ready but equally wouldn't recommend lessons for the sake of it. He treats everyone as an individual. An honest, genuine, guy. Less than two months after starting driving again, I've passed my test. This will be life changing for me, thank you Paul! 🚗🚗",
    rating: 5,
    photo: "https://customer-assets.emergentagent.com/job_learn-manual/artifacts/8ak2bjhs_sarah.jpg",
    result: "Passed After Confidence Rebuild"
  },
  {
    id: 6,
    name: "Beth",
    location: "Greenock",
    text: "After recently passing my test with Paul I couldn't not leave him a review! Paul was a fantastic instructor who created a calm environment for me during every lesson. He was constructive but very supportive and I felt really safe in the car with him. As someone who started driving very nervous, he certainly built my confidence and was very patient whilst I got to know the roads up in Scotland. Could not thank Paul enough and recommend to any of my Scotland pals looking for an instructor 🚘 I've finished my lessons with parallel parking being my favourite manoeuvre which I think says it all on his skill as an instructor 😂😂",
    rating: 5,
    photo: "https://customer-assets.emergentagent.com/job_learn-manual/artifacts/s0008wav_Beth.jpg",
    result: "Mastered All Maneuvers"
  },
  {
    id: 7,
    name: "Sophie H",
    location: "Greenock",
    text: "When I started driving I had a different instructor that I wasn't happy with, Then I got recommended that I should go out with paul for lessons, When I first went out with paul I could notice that he was very kind, mindful and patient in every situation that you could imagine! I would 100% recommend paul as he is great! I honestly don't think I would have passed my test if it wasn't for me going out with paul! Although I did nearly hit a few Curbs in my lessons giving him a heart attack!🤣",
    rating: 5,
    photo: "https://customer-assets.emergentagent.com/job_learn-manual/artifacts/1jo4umja_sophieH_Pass.jpg",
    result: "Switched & Succeeded"
  },
  {
    id: 8,
    name: "Siobhan",
    location: "Greenock",
    text: "I recently passed my test first time with pauls help and I have to say his patience and friendly atmosphere in the car is incredibly helpful if you are an anxious driver (like myself 😂). It is quite clear he cares for the people he teaches by giving constructive criticism and help whenever possible. I would absolutely recommend paul to anyone. Thank you again for everything! 🙂",
    rating: 5,
    photo: "https://customer-assets.emergentagent.com/job_99a6c986-2fe1-448c-8a49-34deb5cc650b/artifacts/xzt4xyat_Siobhan.jpg",
    result: "Passed First Time"
  },
  {
    id: 9,
    name: "Lewis",
    location: "Greenock",
    text: "I highly recommend Paul as a driving instructor. He is incredibly patient and straight to the point. Since I was unfamiliar with the area, Paul guided me through possible test routes and ensured I felt comfortable with the roads. Having had some driving experience but struggling with certain manoeuvres after failing with my previous instructor, Paul's teaching made a huge difference. He showed me simple, effective techniques for each manoeuvres, significantly boosting my confidence and skill. Remarkably, after just 5 days of intensive driving lessons with Paul, I passed my driving test. His expertise and dedication truly paid off, and I couldn't be more grateful. Thank you Paul!",
    rating: 5,
    photo: "https://customer-assets.emergentagent.com/job_learn-manual/artifacts/mqo4u3is_LewisPass.jpg",
    result: "5-Day Intensive Success"
  },
  {
    id: 9,
    name: "Zoe",
    location: "Inverkip",
    text: "Congratulations to Zoe who passed her driving test with 3DF's! Zoe was my first Drive Johnsons pupil when i started this journey, with me being a new PDI and her being a new learner........ what could go wrong 👀👀 (i'll let her tell you about the 1st time behind the wheel) 🤣🤣 She had took everything on board right from the start, as the months passed and my own Part 3 was fast approaching and after a few discussions, Zoe was my Part 3 pupil !! Not only did she shine on the day, under incredible pressure with a senior examiner in the back , she absolutely smashed it helping me become a fully qualified ADI !! Feedback from Senior Examiner: 'A positive learning atmosphere created. Good interaction between PDI and pupil, who was encouraged to self reflect throughout. Think about your own driving skills and transfer this to pupil. 👏🏻 Well done both of you.'",
    rating: 5,
    photo: "https://customer-assets.emergentagent.com/job_learn-manual/artifacts/ioylsnp0_ZoePass.jpg",
    result: "Helped Qualify Instructor & Passed with 3 Faults"
  },
  {
    id: 10,
    name: "Dylan",
    location: "Skelmorlie",
    text: "When I had first joined with Paul I had only had one other lesson with another instructor. Paul managed to teach me the ways to pass my test within 15 hours of lessons. Paul makes driving lessons comfortable as he was very friendly and remained calm whenever I'd made an error this helped me grow my confidence and learn from my mistakes. I'd highly recommend Paul as he's straight to the main goal of passing your test and doesn't waste any time doing unnecessary lessons.",
    rating: 5,
    photo: "https://customer-assets.emergentagent.com/job_learn-manual/artifacts/5frqais8_DylanPass.jpg",
    result: "Passed in Just 15 Hours"
  },
  {
    id: 11,
    name: "Gordon",
    location: "Wemyss Bay",
    text: "My son learned to drive with Paul and said the following: 'Started lessons with Paul earlier this year and straight away felt at ease during my lessons. Gave clear instructions and great advice on driving techniques. The videos on his socials have also been incredibly helpful. Would definitely recommend'.",
    rating: 5,
    photo: "https://customer-assets.emergentagent.com/job_learn-manual/artifacts/wa6ojb2b_GordonPass.jpg",
    result: "Social Media Support Success"
  }
];

export const aboutInfo = {
  instructorName: "Paul",
  instructorPhoto: "https://customer-assets.emergentagent.com/job_99a6c986-2fe1-448c-8a49-34deb5cc650b/artifacts/td4ktteb_pr1.jpeg",
  experience: "Over 2 years of driving instruction experience",
  qualification: "Fully Qualified DVSA Approved Driving Instructor (ADI)",
  philosophy: "I believe in creating a safe, supportive learning environment where students can develop confidence and essential driving skills at their own pace.",
  specializations: ["Automatic transmission", "Nervous drivers", "Test preparation", "Advanced driving skills"],
  vehicles: {
    automatic: {
      photo: "https://customer-assets.emergentagent.com/job_learn-manual/artifacts/bjfuhozs_Yaris.jpg",
      make: "Toyota Yaris Design",
      engine: "1.5 Hybrid",
      transmission: "Automatic (CVT)",
      power: "116 BHP",
      features: ["Hybrid efficiency", "Dual control pedals", "Excellent visibility", "Comfortable seating", "Easy parking"]
    }
  }
};